import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../assets/imgs/transmate.png';
import _imports_1 from '@/assets/imgs/line_up.png';
const _hoisted_1 = {
  class: "page-view"
};
const _hoisted_2 = {
  class: "global-header"
};
const _hoisted_3 = {
  class: "page-contanter"
};
const _hoisted_4 = {
  class: "contact-box"
};
const _hoisted_5 = {
  class: "qq-box"
};
const _hoisted_6 = ["href"];
const _hoisted_7 = {
  class: "jump-box"
};
import { computed } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'RouteLayout',
  setup(__props) {
    const linkHref = computed(() => {
      return window.jeemaaLink;
    });
    return (_ctx, _cache) => {
      const _component_GlobalHeader = _resolveComponent("GlobalHeader");
      const _component_RouterView = _resolveComponent("RouterView");
      const _component_Footer = _resolveComponent("Footer");
      const _component_el_backtop = _resolveComponent("el-backtop");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_GlobalHeader)]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_RouterView)]), _createVNode(_component_Footer), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_cache[0] || (_cache[0] = _createElementVNode("img", {
        src: _imports_0,
        alt: ""
      }, null, -1)), _createElementVNode("a", {
        target: "_blank",
        class: "text",
        href: linkHref.value
      }, "Transmate下载", 8, _hoisted_6)]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_backtop, {
        right: 40,
        bottom: -10
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createElementVNode("img", {
          class: "jump-up",
          src: _imports_1
        }, null, -1)]))]),
        _: 1
      })])])]);
    };
  }
});